import { Component, OnDestroy, TrackByFunction } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { finalize, map, Observable, Subject, takeUntil } from 'rxjs';

import { IPaperAuthorSearchDialogData } from 'editing-tool/src/app/shared/components/paper/steps/authors/author-search-dialog/paper-author-search-dialog-data';
import { FormAnimations } from 'sc-common';
import { ApiEditingToolFoundMember } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    templateUrl: './paper-author-search-dialog.component.html',
    styleUrls: ['./paper-author-search-dialog.component.scss'],
    animations: [FormAnimations.AnimateDisplay],
    standalone: false
})
export class PaperAuthorSearchDialogComponent implements OnDestroy {

    public filteredAuthors$: Observable<ApiEditingToolFoundMember[]>;

    public selectedAuthors: ApiEditingToolFoundMember[] = [];

    public requestInProcess = false;

    public get saveDisabled(): boolean {
        return !this.selectedAuthors?.length;
    }

    public readonly trackByFunc: TrackByFunction<ApiEditingToolFoundMember> = (_: number, item: ApiEditingToolFoundMember): any => item.memberId;

    private readonly _dialogData: IPaperAuthorSearchDialogData;

    private readonly _destroy$ = new Subject<void>();

    constructor(
        private readonly _dialogRef: DynamicDialogRef,
        dialogConfig: DynamicDialogConfig) {
        this._dialogData = dialogConfig.data as IPaperAuthorSearchDialogData;
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public filterAuthors(query: string): void {
        if (!query) {
            return;
        }

        this.filteredAuthors$ = this._dialogData.findAuthorsRequest(query)
            .pipe(map(foundAuthors =>
                foundAuthors.filter(foundAuthor =>
                    !this.selectedAuthors.some(selectedAuthor =>
                        selectedAuthor.memberId === foundAuthor.memberId))));
    }

    public onSelect(author: ApiEditingToolFoundMember): void {
        if (this.selectedAuthors.some(i => i.memberId === author.memberId)) {
            return;
        }

        this.selectedAuthors.push(author);
    }

    public onUnselect(author: ApiEditingToolFoundMember): void {
        const authorIndex = this.selectedAuthors.findIndex(i => i.memberId === author.memberId);

        this.selectedAuthors.splice(authorIndex, 1);
    }

    public save(): void {
        if (this.saveDisabled) {
            return;
        }

        this.requestInProcess = true;

        this._dialogData.addAuthorsRequest(this.selectedAuthors.map(i => i.memberId))
            .pipe(
                finalize(() => this.requestInProcess = false),
                takeUntil(this._destroy$))
            .subscribe(() => {
                this._dialogRef.close(true);
            });
    }
}
